












































































































import mixins from 'vue-typed-mixins';
import I18nMixin from '@/Shared/I18nMixin';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import BuildEntityComponent from '@/Shared/CommonEntityMixins/EntityComponentMixin';
import RadioToggle from '@/Shared/RadioToggle.vue';
import { LookupsSystemVariables } from '../LookupsSystemVariables';
import { AxiosResponse } from 'axios';
import { FrequencyType, TransferType } from '../Enums';

const component = mixins(LocationBasedMixin, BuildEntityComponent<LookupsSystemVariables>()).extend({
    components: {
        RadioToggle
    },
    data() {
        return {
            i18nPrefix: 'admin.programVariables.lookups',
            FrequencyType,
            frequencyTypeDisplay: Object.keys(FrequencyType),
            TransferType,
            transferTypeDisplay: Object.keys(TransferType),
            ftpPasswordConfirm: ''
        };
    },
    computed: {
        entityUrls() {
            return `${this.location}/lookupsSystem/variables`;
        }
    },
    methods: {
        saveInStateLookups() {
            if (this.entity.inStateLookupFTPPassword) {
                if (this.ftpPasswordConfirm !== this.entity.inStateLookupFTPPassword) {
                    this.validationErrors = {
                        ...this.validationErrors,
                        ftpPasswordConfirm: ['Passwords must match']
                    };

                    return;
                }
            }

            this.saveEntity();
        },
        afterSave(response: AxiosResponse<LookupsSystemVariables>): LookupsSystemVariables {
            const translatedTitle = this.$i18n.t(`${this.i18nPrefix}.saveSuccessTitle`);
            const translatedMessage = this.$i18n.t(`${this.i18nPrefix}.saveSuccessMessage`);
            this.$bvToast.toast(translatedMessage.toString(), {
                title: translatedTitle.toString(),
                autoHideDelay: 5000
            });

            response.data.inStateLookupNextRunDate = new Date(response.data.inStateLookupNextRunDate);
            response.data.inStateLookupLastRunDate = new Date(response.data.inStateLookupLastRunDate);

            return response.data;
        },
        afterLoad(response: AxiosResponse<LookupsSystemVariables>): LookupsSystemVariables {

            response.data.inStateLookupNextRunDate = new Date(response.data.inStateLookupNextRunDate);
            response.data.inStateLookupLastRunDate = new Date(response.data.inStateLookupLastRunDate);

            return response.data;
        },
    }
});

export default component;
